import { useTranslation } from 'react-i18next';

import { AtSymbolOutline, HashtagOutline, PlusOutline } from '@bonusly/design-system';

import { Tag } from '../types';

export interface TagSchema {
	activeBg: string;
	activeIcon: string;
	activeText: string;
	icon: JSX.Element;
	label: string;
	trigger: string;
}

export const useTagSchema = (tag: Tag): TagSchema => {
	const { t } = useTranslation('action_input');

	return {
		amount: {
			activeBg: 'greenAlpha.100',
			activeIcon: 'green.500',
			activeText: 'points.fg',
			icon: <PlusOutline />,
			label: t('decorations.amount_label_short'),
			trigger: '+',
		},
		hashtag: {
			activeBg: 'purpleAlpha.100',
			activeIcon: 'hashtag.fgOnSurface',
			activeText: 'hashtag.fg',
			icon: <HashtagOutline />,
			label: t('decorations.hashtag_label_short'),
			trigger: '#',
		},
		recipient: {
			activeBg: 'blueAlpha.100',
			activeIcon: 'primary.fg',
			activeText: 'primary.fgStrong',
			icon: <AtSymbolOutline />,
			label: t('decorations.recipient_label_short'),
			trigger: '@',
		},
	}[tag];
};
